import { render, staticRenderFns } from "./acknowledgement_checkbox.vue?vue&type=template&id=58b74c2f&"
import script from "./acknowledgement_checkbox.vue?vue&type=script&lang=js&"
export * from "./acknowledgement_checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports